import CookieConsentBanner from './CookieConsentBanner';
import { useCookieConsentStore } from '../../stores/useCookieConsentStore';


function Footer() {
    const manageCookies = async() => {
        useCookieConsentStore.getState().setShowBanner(true);
    }
    return (
        <>
            <CookieConsentBanner />

            <footer className="has-text-centered is-size-7 mt-auto mb-0 pb-5">
                <div>
                    <div className="is-divider is-left"></div>
                </div>
                <div className="mb-4">
                    <div className="columns mt-3 is-mobile">
                        <div className="column">
                            <a href="/privacy">
                                Privacy Info
                            </a>
                        </div>
                        <div className="column">
                            <span>Copyright @2025</span>
                        </div>
                        <div className="column">
                            <div className="is-link is-clickable is-underlined" onClick={manageCookies}>
                                Manage Cookies
                            </div>
                        </div>
                    </div>
                    <br />
                </div>

            </footer>
        </>
    );
}


export default Footer;


